import React from "react";

/** Filter row (search + status + reason) for the bad-leads queue. */
export default function BadLeadsFilters({
  q, setQ, status, setStatus, reason, setReason, enums, onApply,
}) {
  return (
    <div className="brut-card p-4 space-y-3 mt-3" data-testid="badlead-filters">
      <div className="flex items-center gap-2">
        <input
          data-testid="badlead-search"
          placeholder="Search notes or lead ID"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && onApply()}
          className="flex-1 border border-black px-3 py-2"
        />
        <button onClick={onApply}
          className="border border-black px-3 py-2 text-xs uppercase tracking-widest hover:bg-black hover:text-white transition-colors duration-100">
          Apply
        </button>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <div>
          <label className="label-mono">Status</label>
          <select data-testid="badlead-status" className="w-full border border-black px-2 py-1.5 mt-1"
            value={status} onChange={(e) => setStatus(e.target.value)}>
            <option value="">Any</option>
            {(enums.statuses || []).map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>
        <div>
          <label className="label-mono">Reason</label>
          <select data-testid="badlead-reason" className="w-full border border-black px-2 py-1.5 mt-1"
            value={reason} onChange={(e) => setReason(e.target.value)}>
            <option value="">Any</option>
            {(enums.reasons || []).map((r) => <option key={r.code} value={r.code}>{r.label}</option>)}
          </select>
        </div>
      </div>
    </div>
  );
}
